import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useQuery } from '@tanstack/react-query';

export const useBrandsQuery = () => {

  const apiClient = useChatApiClient();

  return useQuery({
    queryKey: ['get:brands'],
    queryFn: () => apiClient.workspaceBrands.getBrands({ take: 6 }).then(res => res.data),
  });
};